import { SourceMapType } from "@/components/FpAppV4/utils/fpAppV4Interface";
import { SIMPLE_CITATION_REGEX } from "../../../constants";
import { wrapConsecutiveCitations } from "./wrapConsequtiveCitations";
import wrapNumericReference from "./wrapNumericReference";

export const convertToRefString = ({
  htmlString = "",
  qid = "",
  sourceMap = {},
}: {
  htmlString: string;
  qid: string;
  sourceMap: SourceMapType;
}): string => {
  htmlString = wrapConsecutiveCitations(htmlString, qid);

  // Only the shared marker grammar becomes a citation. A shorter bracketed
  // decimal is the answer's own figure (`$[20.0] million`) and stays (#12767).
  const markerRegex = new RegExp(SIMPLE_CITATION_REGEX.source, "g");
  htmlString = htmlString.replace(markerRegex, (match) => {
    const reference = sourceMap[match];
    return `<citation id="${match}" qid="${qid}" displaySrcNum="${reference?.[0]?.displaySrcNum}"></citation>`;
  });

  const referencedNums = Object.keys(sourceMap || {});
  const referencedNumsUnique = [...new Set(referencedNums)];

  // remove the referencedNums that of the patternL: \[\d+\.\d+\]
  const referencedNumsFiltered = referencedNumsUnique.filter((numValue) => {
    return !numValue.match(/\[\d+\.\d+\]/);
  });

  htmlString = wrapNumericReference(referencedNumsFiltered, htmlString, qid);
  return htmlString;
};
